import Button from '@components/Button';
import Row from '@components/Row';
import styled from '@emotion/styled';
import Add from '@icons/Add';
import { Link } from '@router/Link';
import { useTranslation } from 'react-i18next';

function ExternalCouponFragment() {
    const { t } = useTranslation('coupon');
    return (
        <Container>
            <Link activityName='NewGiftBottomSheet'
                activityParams={{}}>
                <Button fullWidth>
                    <Row spacing={4}>
                        <Add size={22}/>
                        {t('external.register')}
                    </Row>
                </Button>
            </Link>
        </Container>
    );
}

const Container = styled.div`
    padding: 36px 20px;
`;

export default ExternalCouponFragment;
